<template>
  <div>
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="80"
    >
      <FormItem label="负责人" prop="user_id" >
        <Select v-model="formValidate.user_id">
          <Option
            v-for="item in userIds"
            :value="item.key"
            :key="item.key"
            >{{ item.label}}</Option
          >
        </Select>
      </FormItem>

      <FormItem style="text-align: right">
        <Button @click="handleReset('formValidate')">重置</Button>
        <Button
          type="primary"
          @click="handleSubmit('formValidate')"
          style="margin-left: 8px"
          >提交</Button
        >
      </FormItem>
    </Form>
  </div>
</template>

<script>
import params from '../argu-page/params.vue'
export default {
  components: { params },
  props: {
    resetFlag: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => {}
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      classifyIds: [],
      userIds: [],
      liveTypes: [],
      formValidate: {
        id: '',
        user_id: ''
      },
      ruleValidate: {
        user_id: [
          {
            required: true,
            message: '负责人必须要选择',
            trigger: 'change'
          }
        ]
      }
    }
  },
  watch: {
    resetFlag (resetFlag) {
      this.handleReset('formValidate')
    }
  },
  methods: {
    setUserData (userData) {
      this.userIds = userData
    },
    setEditData (data) {
      this.formValidate.id = data.id
      this.formValidate.user_id = data.flower_id
    },
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$emit('on-ok', this.formValidate)
        } else {
          this.$Message.error('失败!')
        }
      })
    },
    handleReset (name) {
      this.$refs[name].resetFields()
    }
  }
}
</script>
